import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["subCategoryPanel", "subCategoryGroup"];

  static values = {
    persistedTags: Array,
    workflowType: String,
  };

  connect() {
    this.syncGroups();
  }

  syncGroups() {
    const selectedSection = this.selectedSectionSlug();
    this.subCategoryGroupTargets.forEach((group) => {
      const section = group.dataset.section;
      const visible = section === selectedSection;
      group.classList.toggle("d-none", !visible);
      if (!visible) {
        group.querySelectorAll('input[type="checkbox"]').forEach((input) => {
          input.checked = false;
        });
      }
    });
  }

  collectAccessTags() {
    const tags = new Set(Array(this.persistedTagsValue));

    Array.from(tags).forEach((tag) => {
      if (tag.startsWith("sub_category:") || tag.startsWith("section:")) tags.delete(tag);
    });

    const sectionInput = this.element.querySelector(
      'input[type="radio"][name="academy_article[access_tags][]"][value^="section:"]:checked'
    );
    if (sectionInput) {
      tags.add(sectionInput.value);
    } else if (this.selectedSectionSlug() === "platform_guide") {
      tags.add("section:platform_guide");
    }

    this.element
      .querySelectorAll('input[type="checkbox"][name="academy_article[access_tags][]"][value^="sub_category:"]:checked')
      .forEach((input) => tags.add(input.value));

    return Array.from(tags);
  }

  selectedSectionSlug() {
    const checked = this.element.querySelector(
      'input[type="radio"][name="academy_article[access_tags][]"][value^="section:"]:checked'
    );
    if (checked) return checked.value.split(":", 2)[1];

    return "platform_guide";
  }
}
